module.exports = __webpack_public_path__ + "static/img/SaaSflimg.7eaeb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SaaSflimg.png
// module id = LGh5
// module chunks = 1